(function () {

  angular
    .module('meanApp')
    .directive('bgHomeImage', bgHomeImage);

  function bgHomeImage () {
    return {
        link: function(scope, element, attr) {

            attr.$observe('bgHomeImage', function() {           
              if (!attr.bgHomeImage) {
                 // No attribute specified, so use default
                 element.css("background","url("+scope.defaultImage+")");
              } else {
                 var image = new Image();  
                 image.src = attr.bgHomeImage;
                 image.onload = function() { 
                    //Image loaded- set the background image to it
                    //element.css("background-image","url("+attr.bgHomeImage+")");
                    element.css("background-image","linear-gradient( rgba(0, 0, 0, 0), rgba(63, 34, 3, 0.5), rgba(63, 34, 3, 0.6) ), url("+attr.bgHomeImage+")");
                    element.css("background-repeat", "no-repeat"); 
                    element.css("background-size", "cover");
                 };
                 image.onerror = function() {
                    //Image failed to load- use default
                    element.css("background-image","url("+scope.defaultImage+")");
                 };
             }
         });
      }
    };
  }

})();